import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";

const tools = [
  { name: "Math Solver", icon: "ri-calculator-line", to: "/formula" },
  { name: "Note Making", icon: "ri-file-list-3-line", to: "/notemaking" },
  { name: "Paraphrase", icon: "ri-quill-pen-line", to: "/paraphrase" },
  { name: "Extract Text", icon: "ri-image-line", to: "/extract" },
];

const Company = () => {
  return (
    <section className="bg-brand-surface py-[72px]" id="tools">
      <Container>
        <div className="mb-9 max-w-[560px]">
          <p className="section-label">Study toolkit</p>
          <h2 className="m-0">Everything you need for clearer learning</h2>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {tools.map((tool) => (
            <Link
              key={tool.to}
              to={tool.to}
              className="flex items-center gap-3.5 rounded-2xl border border-brand-forest/10 bg-white px-5 py-4 no-underline transition hover:-translate-y-0.5 hover:border-brand-teal/55 hover:shadow-brand"
            >
              <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-soft">
                <i className={`${tool.icon} text-[1.35rem] text-brand-teal-dark`} />
              </span>
              <span className="flex-1 font-display text-base font-semibold text-brand-forest">
                {tool.name}
              </span>
              <i className="ri-arrow-right-up-line text-[1.15rem] text-brand-teal opacity-70" />
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Company;
